import classNames from 'classnames/bind';
import React from 'react';
import { ICONS, Icon } from '@creditsights/styleguide-web';
import styles from './Error.module.scss';

const cx = classNames.bind(styles);

type ErrorProps = {
  error: JSX.Element | string;
};

const ErrorContainer = ({ error }: ErrorProps): React.ReactElement => (
  <div className={cx('body')}>
    <Icon name={ICONS.Alert} />
    <span>{error}</span>
  </div>
);

export default ErrorContainer;
